export const RATE_TYPE_VALUE_TO_LABEL = {
  'pact/faa': 'PACT/FAA',
  'pact/equity': 'PACT/Equity',
  'bbc/equity': 'BBC/Equity',
  commercial: 'Commercial',
  'non-union': 'Non-union',
  unscripted: 'Unscripted',
  other: 'Other',
};
